<template>
  <div class="tool-card" @click="handlClick">
    <el-card body-style="padding: 0;background-color: #f0f5f9;" shadow="hover">
      <el-row>
        <el-col class="card-icon" :span="7">
          <i v-if="icon" :class="icon"></i>
          <img v-else-if="img" :src="img" :alt="iconDesc" />
        </el-col>
        <el-col :span="17" class="card-info">
          <el-row>
            <el-col>
              <h1 class="card-title">{{ title }}</h1>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div class="intro">
                <span>{{ intro }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ToolCard',
  props: {
    title: String,
    intro: String,
    tool: String,
    icon: String,
    img: String,
    iconDesc: String
  },
  methods: {
    handlClick() {
      if ('life_restart' == this.tool) {
        location.href = "/life_restart/view/index.html"
      }
      this.$router.push({ name: this.tool })
    }
  }
}
</script>

<style scoped>
.tool-card {
  width: 300px;
  height: 150px;
  cursor: pointer;
}
.card-info {
  opacity: 0.8;
}
.tool-card:hover .card-info {
  opacity: 1;
}
.card-icon {
  vertical-align: middle;
  text-align: center;
  line-height: 150px;
}
.card-icon>img {
  padding-top: 2.5em;
  width: 3em;
}
.card-title {
  color: #409EFF;
}
.intro {
  font-size: 0.9em;
  padding-right: 2em;
  color: #838B8B;
}
</style>